import {
  storageUtil,
  fetchUserPermissions,
  fetchCulture,
} from "../utils/commonFunctions";
import UserSession from "../utils/userSessionClass";
import { themesList } from "../utils/themes";


export const formatPermissions = (perArr, userRole, userName) => {
  const permissions = {};
  perArr.forEach((item) => {
    const { resource, action } = item;
    if (!permissions[userRole]) {
      permissions[userRole] = {
        role: [userName, userRole],
      };
    }
    if (permissions[userRole][action]) {
      permissions[userRole][action].push(resource);
    } else {
      permissions[userRole][action] = [resource];
    }
  });
  if (permissions) {
    localStorage.setItem('userPermissions', JSON.stringify(permissions));
  }
};


export const initializeSsoSession = async (
  ssoUser,
  navigate,
  updateTheme,
  setUserTheme,
  setLoginMessage,
) => {
  const email = (ssoUser.userName || "").toLowerCase();
  const isForthcodeDomain = email.endsWith("@forthcode.com");

  const domain = process.env.REACT_APP_ACCOUNT_DOMAIN || "forthcode.com";

  if (!isForthcodeDomain) {
    if (setLoginMessage) {
      setLoginMessage({
        error: "Access Denied: SSO is restricted to forthcode.com domain.",
      });
    }
    return;
  }

  const userSession = new UserSession();
  updateTheme();

  const csrfToken = ssoUser.csrfToken || ssoUser.token;
  const headers = {
    "x-csrf-token": csrfToken,
  };

  localStorage.setItem(
    "login_credentials",
    JSON.stringify({ data: ssoUser, headers }),
  );
  localStorage.setItem("token", csrfToken);
  localStorage.setItem("bearer_token", ssoUser.token);
  localStorage.setItem("sType", ssoUser.userName);

  const userType = ssoUser.userType;
  let userRole = ssoUser.userRole || `${userType}-role`;
  userRole = userRole.replace(/['"]+/g, ''); // Remove double quotes attached to userRole

  const userName = ssoUser.userName;
  const userId = ssoUser.userId;
  const employeeId = userId || userName;

  storageUtil.set("employeeId", employeeId, "local");
  storageUtil.set("userType", userType, "local");
  
  storageUtil.set("userRole", userRole, "local");
  storageUtil.set("domain", domain, "local");


  try {
    const hdrObj = {
      userId: employeeId,
      data: { ...ssoUser, token: ssoUser.token },
      headers,
    };
    const permissionsResp = await fetchUserPermissions(hdrObj, {
      subject: userName,
      userRole,
    });

    if (permissionsResp?.items?.length) {
      formatPermissions(permissionsResp.items, userRole, userName);
    }
  } catch (err) {
    console.error(
      "[SSO Service] Error fetching user permissions via API:",
      err,
    );
  }

  const themeToApply =
    themesList.find((t) => t.keyname === ssoUser.theme?.keyname) ||
    themesList[0];
  if (setUserTheme) {
    setUserTheme(themeToApply);
  }
  ssoUser.theme = themeToApply;

  try {
    const resCulture = await fetchCulture();
    if (resCulture) {
      localStorage.setItem("NGO_CULTURE", JSON.stringify(resCulture));
    }
  } catch (_) {
    localStorage.setItem("NGO_CULTURE", JSON.stringify({ timezone: "UTC" }));
  }

  userSession.setSession({
    ...ssoUser,
    userId: employeeId,
    token: ssoUser.token,
  });

  navigate("/");
};
